var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],staticClass:"close-icon position-absolute right-0 text-danger",on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":"x","size":"xs"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }